import {get, handleErrors} from '../api';

const DEFAULT_REC_COUNT = 3;
const WEB_APP_CONSUMER_KEY = "86291-f8d3e654be359e75b7625e79";
const SYNDICATED_ARTICLE_PATH = 'syndicated_article';
const SYNDICATED_PUBLISHER_PATH = 'syndicated_publisher';
const RECIT_PATH = '/v3/recit/module';

const handleRecitRequest = endpoint => (onSuccess, onError) => {
  get(endpoint)
  .then(response => {
    if (response.recommendations) {
      onSuccess(response);
    } else {
      onError(response)
    }
  })
  .catch(error => console.log('Error:', error));
}

const getSyndicatedArticleRecs = (resolvedId, onSuccess, onError) => {
  const endpoint = `${RECIT_PATH}/${SYNDICATED_ARTICLE_PATH}/${resolvedId}?limit=${DEFAULT_REC_COUNT}&consumer_key=${WEB_APP_CONSUMER_KEY}`;

  handleRecitRequest(endpoint)(onSuccess, onError);
}

const getPublisherRecs = (resolvedId, onSuccess, onError) => {
  const endpoint = `${RECIT_PATH}/${SYNDICATED_PUBLISHER_PATH}/${resolvedId}?limit=${DEFAULT_REC_COUNT}&consumer_key=${WEB_APP_CONSUMER_KEY}`;

  handleRecitRequest(endpoint)(onSuccess, onError);
}

export {
  getSyndicatedArticleRecs,
  getPublisherRecs
}
